// extracted by mini-css-extract-plugin
module.exports = {"multiLineAddressWrapper":"MD","phoneWrapper":"ND","isSelected":"OD","forceWrap":"PD"};